<script setup>
import { ref, watch } from "vue";

import "vue3-tel-input/dist/vue3-tel-input.css";
import useVuelidate from "@vuelidate/core";
import contentApi from "@/apis/contentApi";

const props = defineProps({
  profileBasicInformationFormModal: {},
});

const emits = defineEmits([]);
const profileBasicInformationFormModalRef = ref(null);
const countriesRef = ref(null);

watch(
  () => props.profileBasicInformationFormModal,
  (newValue) => {
    profileBasicInformationFormModalRef.value = newValue;
  },
  { immediate: true, deep: true }
);

let rules = {
  // surname: { surnameRule },
  // givenName: { givenNameRule },
};

const v = useVuelidate(rules, profileBasicInformationFormModalRef);

function getCountries(keyword) {
  document.getElementById("country-dropdown-menu").classList.add("show");
  contentApi.countries(keyword).then((res) => {
    countriesRef.value = res.data;
  });
}

function selectCountry(country, menuId) {
  // partyBasicInfoFormModelRef.value.birthPlaceCountryId = country.code;
  // partyBasicInfoFormModelRef.value.birthPlaceCountry = country.name;
  document.getElementById(menuId).classList.remove("show");
}

function modifyTravelDocuments(profileBasicInformationFormModal) {
  emits("modifyTravelDocuments", profileBasicInformationFormModal);
}
</script>

<template>
  <form
    action="!#"
    id="profile_form_area"
    @submit.prevent="modifyTravelDocuments()"
  >
    <h3>Let’s confirm your email</h3>
    <div class="font-14">
      To continue, enter the secure code we sent to
      christophercheng@hotmail.com. Check junk mail if it’s not in your inbox.
    </div>
    <div class="row mg-t-20">
      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            id="profile-emailAddress"
            name="profile-emailAddress"
            placeholder="6-digit code"
          />
        </div>
      </div>
    </div>

    <div class="col-lg-12" align="center">
      <button class="btn btn_theme">{{ $t("continue") }}</button>
    </div>
  </form>
</template>

<style scoped></style>
